export const replaceString = (text: string, replaceText: string) =>
  text.replace(/:id|{n}/g, replaceText)
